/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the wrin permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Tue Nov 26 2024
 **/

import emoji1 from "./emoji1.svg";
import emoji2 from "./emoji2.svg";
import emoji3 from "./emoji3.svg";
import emoji4 from "./emoji4.svg";
import emoji5 from "./emoji5.svg";
import emoji6 from "./emoji6.svg";
import emoji7 from "./emoji7.svg";
import emoji8 from "./emoji8.svg";
import emoji9 from "./emoji9.svg";
import emoji10 from "./emoji10.svg";
import emoji11 from "./emoji11.svg";
import emoji12 from "./emoji12.svg";

const emojiIcons = [emoji1, emoji2, emoji3, emoji4, emoji5, emoji6, emoji7, emoji8, emoji9, emoji10, emoji11, emoji12];
export default emojiIcons;
